import { useState, useEffect } from "react"
import Card from "@mui/material/Card"
import { Button, MenuItem, TextField } from "@mui/material"
import Table from "@mui/material/Table"
import TableBody from "@mui/material/TableBody"
import TableCell from "@mui/material/TableCell"
import TableHead from "@mui/material/TableHead"
import TableRow from "@mui/material/TableRow"
import { mapbox_to_geojson } from "../utils/layer_actions"
import facility_types from "../configs/facility_types.json"

export default function EditFacility({
  current_edit_facility,
  dispatch_map_data,
  dispatch_ui,
}) {
  const [form_data, set_form_data] = useState(null)

  useEffect(() => {
    if (!current_edit_facility) {
      return
    }
    set_form_data(current_edit_facility.properties)
  }, [current_edit_facility])

  const handle_change = (property, value) => {
    let new_form_data = { ...form_data }
    new_form_data[property] = value
    set_form_data(new_form_data)
  }

  if (!current_edit_facility || !form_data) {
    return null
  }

  return (
    <Card
      style={{
        position: "absolute",
        top: "70px",
        right: "10px",
        zIndex: 500,
        maxHeight: 500,
        overflow: "auto",
      }}
    >
      <Table size="small">
        <TableHead>
          <TableRow>
            <TableCell>
              <b>Facility Property</b>
            </TableCell>
            <TableCell align="right">
              <b>Value</b>
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          <TableRow>
            <TableCell component="th" scope="row">
              Name
            </TableCell>
            <TableCell component="th" scope="row">
              <TextField
                value={form_data.name}
                variant="standard"
                size="small"
                onChange={(event) => {
                  handle_change("name", event.target.value)
                }}
              />
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell component="th" scope="row">
              Type
            </TableCell>
            <TableCell component="th" scope="row">
              <TextField
                select
                value={form_data.type}
                variant="standard"
                fullWidth
                size="small"
                onChange={(event) => {
                  handle_change("type", event.target.value)
                }}
              >
                {facility_types
                  .sort((a, b) => a.type.localeCompare(b.type))
                  .map(({ type }) => (
                    <MenuItem value={type} key={type}>
                      {type}
                    </MenuItem>
                  ))}
              </TextField>
            </TableCell>
          </TableRow>
        </TableBody>
      </Table>
      <Button
        onClick={() => {
          let facility = mapbox_to_geojson(current_edit_facility)
          facility = {
            ...facility,
            properties: { ...facility.properties, ...form_data },
          }
          dispatch_map_data({
            type: "UPDATE_FACILITY",
            payload: {
              facility,
            },
          })
          dispatch_ui({ type: "SET_EDIT_FACILITY", payload: { feature: null } })
        }}
        fullWidth
      >
        Update Local
      </Button>

      <Button
        onClick={() => {
          dispatch_ui({ type: "SET_EDIT_FACILITY", payload: { feature: null } })
        }}
        fullWidth
      >
        Cancel
      </Button>
    </Card>
  )
}
